import Component from "@glimmer/component";
import RadioCheckboxTile from "glesys-controlpanel/components/radio-checkbox-tile";
import Select, { Option } from "glesys-controlpanel/components/select";
import Box from "glesys-controlpanel/components/box";
import { t } from "ember-intl";
import { on } from "@ember/modifier";

const Engine = class extends Component {
  selectedVersion = (event) => {
    const selected = this.args.engine.versions.find((version) => version.id === event.target.value);
    this.args.onChange({ ...this.args.engine, selected });
  };

  <template>
    <div
      class="grid grid-rows-[1fr_auto] gap-4 rounded-lg border overflow-hidden h-full hover:border-gray-300 has-[input:checked]:border-black has-[input:checked]:hover:border-black has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-blue-700 has-[input:focus-visible]:ring-offset-2"
      data-test-select-engine={{@engine.label}}
    >
      <RadioCheckboxTile
        class="border-0 rounded-none items-start [--image-height:--spacing(8)] grid grid-rows-[var(--image-height)_auto] gap-4 has-focus-visible:ring-0 has-focus-visible:ring-offset-0"
        data-test-select-engine-radio
        @group="database-engine"
        @onChange={{@onChange}}
        @value={{@engine}}
        @selected={{@selected}}
        @key="label"
      >
        <img class="h-full" src={{@engine.icon}} alt={{@engine.label}} />
        <div>
          <p class="text-md">{{@engine.label}}</p>
          <p class="text-gray-500 text-start">{{@engine.description}}</p>
        </div>
      </RadioCheckboxTile>
      <Select
        class="rounded-none border-0 border-t bg-transparent"
        aria-label={{t "databases.create.engines.select-version-label" engine=@engine.label}}
        data-test-select-engine-version
        @value={{@engine.selected.id}}
        {{on "change" this.selectedVersion}}
      >
        {{#each @engine.versions as |version|}}
          <Option value={{version.value}}>
            {{t "databases.create.version" version=version.value}}
          </Option>
        {{/each}}
      </Select>
    </div>
  </template>
};

<template>
  <Box>
    <:header>{{t "label.engine"}}</:header>
    <:default>
      <div class="grid grid-cols-1 @lg:grid-cols-3 gap-4">
        {{#each @engines as |engine|}}
          <Engine @engine={{engine}} @onChange={{@onChange}} @selected={{@selected}} />
        {{/each}}
      </div>
    </:default>
  </Box>
</template>
